import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

var firebaseConfig = {
    apiKey: "AIzaSyBvVlaTKt3CCK80itzCWTtfPfVx4XiN7z4",
    authDomain: "kulukirjanpito-b7755.firebaseapp.com",
    databaseURL: "https://kulukirjanpito-b7755.firebaseio.com",
    projectId: "kulukirjanpito-b7755",
    storageBucket: "kulukirjanpito-b7755.appspot.com",
    messagingSenderId: "606531279732",
    appId: "1:606531279732:web:78e056da0705db17af2a21"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();

export default firebase;
